export const GLOBAL_API_URL = "/api/global";

export type PublicConfig = {
  sdfPlatform: {
    APP_URL: string;
  };
  privy: {
    PRIVY_APP_ID: string;
  };
};

export async function fetchPublicConfig(): Promise<PublicConfig> {
  const result = await fetch(`${GLOBAL_API_URL}/v1/config`, {
    headers: {
      Accept: "application/json",
    },
  });

  if (!result.ok) {
    throw new Error(`Failed to load public config: ${result.status}`);
  }

  return (await result.json()) as PublicConfig;
}
